import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { getUserPermissions, isAuthenticated } from "../lib/auth/authHelper";

function hasPermission(permissions, code) {
  return Array.isArray(permissions) && permissions.includes(code);
}

function hasAnyPermission(permissions, codes = []) {
  return Array.isArray(permissions) && codes.some((code) => permissions.includes(code));
}

export default function PermissionRoute({
  permission,
  anyPermissions,
  children,
  redirectTo = "/menu/dashboard",
}) {
  const [authState, setAuthState] = useState(() => ({
    authenticated: isAuthenticated(),
    permissions: getUserPermissions(),
  }));

  useEffect(() => {
    const syncAuthState = () => {
      setAuthState({
        authenticated: isAuthenticated(),
        permissions: getUserPermissions(),
      });
    };

    window.addEventListener("storage", syncAuthState);
    window.addEventListener("token-changed", syncAuthState);
    window.addEventListener("permissions-updated", syncAuthState);

    return () => {
      window.removeEventListener("storage", syncAuthState);
      window.removeEventListener("token-changed", syncAuthState);
      window.removeEventListener("permissions-updated", syncAuthState);
    };
  }, []);

  const { authenticated, permissions } = authState;

  if (!authenticated) {
    return <Navigate to="/" replace />;
  }

  if (permission && !hasPermission(permissions, permission)) {
    return <Navigate to={redirectTo} replace />;
  }

  if (
    anyPermissions &&
    anyPermissions.length > 0 &&
    !hasAnyPermission(permissions, anyPermissions)
  ) {
    return <Navigate to={redirectTo} replace />;
  }

  return children;
}